import { useTheme } from '../context/ThemeContext';
import ByeWind from '../assets/images/ByeWind.png';
import ChartPie from '../assets/icons/light/ChartPieSlice.svg';
import ChartPieDark from '../assets/icons/dark/ChartPieSlice.svg';
import ShopOpen from '../assets/icons/light/ShoppingBagOpen.svg';
import ShopOpenDark from '../assets/icons/dark/ShoppingBagOpen.svg';
import Folder from '../assets/icons/dark/FolderNotch.svg';
import LightFolder from '../assets/icons/light/FolderNotch.svg';
import OpenBook from '../assets/icons/dark/BookOpen.svg';
import LightOpenBook from '../assets/icons/light/BookOpen.svg';
import IdenticationBadge from '../assets/icons/dark/IdentificationBadge.svg';
import LightIdentificationBadge from '../assets/icons/light/IdentificationBadge.svg'
import IdentyCard from '../assets/icons/dark/IdentificationCard.svg'
import LightIdentyCard from '../assets/icons/light/IdentificationCard.svg'
import UsersThree from '../assets/icons/dark/UsersThree.svg'
import LightUsersThree from '../assets/icons/light/UsersThree.svg'
import NoteBook from '../assets/icons/dark/Notebook.svg'
import LightNoteBook from '../assets/icons/light/Notebook.svg'
import Chats from '../assets/icons/dark/ChatsTeardrop.svg'
import LightChats from '../assets/icons/light/ChatsTeardrop.svg'
import '../App.css';
import { useNavigate } from 'react-router-dom';


function Sidebar({ isOpen }) {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const navigateToHome = () => {
    navigate('/');
  };

  return (
    <aside
      className={`fixed top-0 left-0 h-full w-[212px] border-r-2 transition-transform duration-900 z-40 ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } ${theme === '#1c1c1c' ? 'bg-[#1c1c1c] text-white border-[#333333]' : 'bg-white text-black border-[#e8e8e8]'}`}
    >
    <div className="flex flex-col justify-between p-4 gap-4">
        <div className='flex p-2 gap-2'>
            <img src={ByeWind} alt="ByeWind" className='w-[24px] h-[24px] rounded-full' />
            <p>ByeWind</p>
        </div>
        <div className='flex flex-col'>
            <div className='flex gap-4 cursor-default'>
                <p className={`text-sm py-1 px-2 ${theme === '#1c1c1c' ? 'text-[#FFFFFF66] hover:bg-[#333333] rounded-lg' : 'text-[#1C1C1C66] hover:bg-[#f3f3f3] rounded-lg'}`}>Favourites</p>
                <p className={`text-sm py-1 px-2 ${theme === '#1c1c1c' ? 'text-[#494949] hover:bg-[#333333] rounded-lg' : 'text-[#d2d2d2] hover:bg-[#f3f3f3] rounded-lg'}`}>Recently</p>
            </div>
            <ul className='flex flex-col p-2 gap-2 ml-2'>
                <div className="flex items-center gap-2">
                  <span
                    className="inline-block w-1.5 h-1.5 rounded-full bg-[#d2d2d2]"
                  ></span>
                  <span className='text-sm'>
                    Overview
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span
                    className="inline-block w-1.5 h-1.5 rounded-full bg-[#d2d2d2]"
                  ></span>
                  <span className='text-sm'>
                    Projects
                  </span>
                </div>
            </ul>
        </div>
        <div className='flex flex-col p-2'>
            <p className={`text-sm mb-2 ${theme === '#1c1c1c' ? 'text-[#FFFFFF66]' : 'text-[#1C1C1C66]'}`}>Dashboards</p>
            <div className='flex flex-col gap-1'>
                <div onClick={navigateToHome} className={`flex ${theme === '#1c1c1c' ? 'hover:bg-[#333333]' : 'hover:bg-[#f4f4f4]'} rounded-md p-1 cursor-pointer`}>
                    <img src={theme === '#1c1c1c' ? ChartPieDark : ChartPie} alt="Chart Pie" className='w-[20px] h-[20px]' />
                    <p className='text-sm px-2'>Default</p>
                </div>
                <div className={`flex ${theme === '#1c1c1c' ? 'hover:bg-[#333333]' : 'hover:bg-[#f4f4f4]'} rounded-md p-1 cursor-pointer`}>
                    <img src={theme === '#1c1c1c' ? ShopOpenDark : ShopOpen} alt="Shop Open" className='w-[20px] h-[20px]' />
                    <p className='text-sm px-2'>eCommerce</p>
                </div>
                <div className={`flex ${theme === '#1c1c1c' ? 'hover:bg-[#333333]' : 'hover:bg-[#f4f4f4]'} rounded-md p-1 cursor-pointer`}>
                    <img src={theme === '#1c1c1c' ? Folder : LightFolder} alt="Folder" className='w-[20px] h-[20px]' />
                    <p className='text-sm px-2'>Projects</p>
                </div>
                <div className={`flex ${theme === '#1c1c1c' ? 'hover:bg-[#333333]' : 'hover:bg-[#f4f4f4]'} rounded-md p-1 cursor-pointer`}>
                    <img src={theme === '#1c1c1c' ? OpenBook : LightOpenBook} alt="Open Book" className='w-[20px] h-[20px]' />
                    <p className='text-sm px-2'>Online Courses</p>
                </div>
            </div>
        </div>
        <div className='flex flex-col p-2'>
            <p className={`text-sm mb-2 ${theme === '#1c1c1c' ? 'text-[#FFFFFF66]' : 'text-[#1C1C1C66]'}`}>Pages</p>
            <div className='flex flex-col gap-1'>
                <div className={`flex ${theme === '#1c1c1c' ? 'hover:bg-[#333333]' : 'hover:bg-[#f4f4f4]'} rounded-md p-1 cursor-pointer`}>
                    <img src={theme === '#1c1c1c' ? IdenticationBadge : LightIdentificationBadge} alt="Chart Pie" className='w-[20px] h-[20px]' />
                    <p className='text-sm px-2'>User Profile</p>
                </div>
                <div className={`flex ${theme === '#1c1c1c' ? 'hover:bg-[#333333]' : 'hover:bg-[#f4f4f4]'} rounded-md p-1 cursor-pointer`}>
                    <img src={theme === '#1c1c1c' ? IdentyCard : LightIdentyCard} alt="Shop Open" className='w-[20px] h-[20px]' />
                    <p className='text-sm px-2'>Account</p>
                </div>
                <div className={`flex ${theme === '#1c1c1c' ? 'hover:bg-[#333333]' : 'hover:bg-[#f4f4f4]'} rounded-md p-1 cursor-pointer`}>
                    <img src={theme === '#1c1c1c' ? UsersThree : LightUsersThree} alt="Folder" className='w-[20px] h-[20px]' />
                    <p className='text-sm px-2'>Corporate</p>
                </div>
                <div className={`flex ${theme === '#1c1c1c' ? 'hover:bg-[#333333]' : 'hover:bg-[#f4f4f4]'} rounded-md p-1 cursor-pointer`}>
                    <img src={theme === '#1c1c1c' ? NoteBook : LightNoteBook} alt="Open Book" className='w-[20px] h-[20px]' />
                    <p className='text-sm px-2'>Blog</p>
                </div>
                <div className={`flex ${theme === '#1c1c1c' ? 'hover:bg-[#333333]' : 'hover:bg-[#f4f4f4]'} rounded-md p-1 cursor-pointer`}>
                    <img src={theme === '#1c1c1c' ? Chats : LightChats} alt="Open Book" className='w-[20px] h-[20px]' />
                    <p className='text-sm px-2'>Social</p>
                </div>
            </div>
        </div>
    </div>
    </aside>
  );
}

export default Sidebar;
